<i18n>
{
  "de": {
    "pageTitle": "Shop"
  },
  "en": {
    "pageTitle": "Shop"
  }
}
</i18n>

<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <!-- Sidenav (hidden on mobile) -->
          <div
            class="column"
            :class="isMobileView ? 'is-hidden' : 'is-one-quarter'"
          >
            <sidenav />
          </div>

          <!-- Unified Shop Content (all items) -->
          <div class="column">
            <!-- Active Filter Indicator for Mobile -->
            <active-filter-indicator @visibility-changed="onFilterIndicatorVisibilityChanged" />

            <shop-content />
          </div>
        </div>
      </div>

      <!-- Desktop Shop Filters (rendered in sidenav via portal) -->
      <portal to="desktopFilterShop">
        <filter-shop />
      </portal>
    </section>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import sidenav from '~/components/sidenav'
import ShopContent from '~/components/shop/index.vue'
import FilterShop from '~/components/filter-shop'
import ActiveFilterIndicator from '~/components/active-filter-indicator'
import artistPageHead from '~/mixins/artistPageHead'

export default {
  name: 'ShopPage',

  mixins: [artistPageHead],

  components: {
    sidenav,
    ShopContent,
    FilterShop,
    ActiveFilterIndicator
  },

  transition: {
    name: 'shop-page',
    mode: 'out-in'
  },

  data() {
    return {
      filterIndicatorVisible: false
    }
  },

  mounted() {
    // Set filter type to null (show all) when on main shop page
    this.setShopFilter({ type: null })
  },

  methods: {
    ...mapActions(['setShopFilter']),

    onFilterIndicatorVisibilityChanged(isVisible) {
      this.filterIndicatorVisible = isVisible
    }
  }
}
</script>

<style lang="scss" scoped>
// Page uses standard profile layout with sidenav
</style>
